// src/components/Footer.jsx
import React from "react";
import "../css/admin-footer.css";

const Footer = () => {
    return (
        <footer className="admin-footer">
            © {new Date().getFullYear()} Magnum Digital solutions. All rights reserved.
        </footer>
    );
};

export default Footer;
